import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReporterService} from '@core/services/reporter.service';
import {User} from '@shared/models/user';
import {Subscription} from 'rxjs';
import {UserService} from '@core/services/user.service';
import {ReporterButtonsService} from '@core/services/reporter-button/reporter-buttons.service';
import {Match} from '@shared/models/match';

@Component({
  selector: 'app-desktop-reporter-matches-card',
  templateUrl: './desktop-reporter-matches-card.component.html',
  styleUrls: ['./desktop-reporter-matches-card.component.scss']
})
export class DesktopReporterMatchesCardComponent implements OnInit, OnDestroy {
  @Input() match: Match;

  linkToReporter: string;

  user: User;
  showReporterButtons: boolean = false;

  userSubscr: Subscription;

  constructor(
    private reporterService: ReporterService,
    private userService: UserService,
    private reporterButtonsService: ReporterButtonsService,
  ) { }

  ngOnInit(): void {
    this.linkToReporter = this.reporterService.getReporterMatchesWebsiteLink();

    this.userSubscr = this.userService.currentUserSubject.subscribe(user => {
      this.user = user;
      this.checkIfReporterButtonsShouldBeShown();
    });
    this.user = this.userService.currentUser;
    this.checkIfReporterButtonsShouldBeShown();
  }

  ngOnDestroy(): void {
    this.userSubscr.unsubscribe();
  }

  private checkIfReporterButtonsShouldBeShown() {
    this.showReporterButtons = this.reporterButtonsService.checkIfUserIsTeamReporterOfHomeOrAwayTeam(
      this.user,
      this.match
    );
  }
}
